// import { doSearchStoreAction, loadGridColumnSettingStoreAction, loadSavedFilterStoreAction } from '../../../../Generic/SearchPage/actions/searchPageActions';
import { globalUserFilterActions as searchPageSliceActions } from '../slices/globalSearchSlice';
import { ObjectTypes } from '../../../../utils/constants';
import { doSearchStoreAction, loadGridColumnSettingStoreAction, loadSavedFilterStoreAction } from '../../../../pages/Generic/SearchPage/actions/searchPageActions';

const getStateSliceForSearchPage = (state) => state.userSearch;
export const loadGridColumnSettingStoreActionHandler = () => async (dispatch, getState) => loadGridColumnSettingStoreAction({
  dispatch,
  getState,
  searchPageSliceActions,
  getStateSliceForSearchPage,
  objectTypeGridColumns: ObjectTypes.UserSearchGrid
});

export const loadSavedFilterStoreActionHandler = () => async (dispatch, getState) => loadSavedFilterStoreAction({ dispatch, getState, searchPageSliceActions, getStateSliceForSearchPage, objectTypeForSaveUserFilter: ObjectTypes.UserSearchUserFilter });

export const doSearchStoreActionHandler = () => async (dispatch, getState) => {
  const searchParamBuilder = (filter) => ({
    client: filter?.Client?.id ?? null,
    reportAddress: filter?.ReportAddress ?? null,
    scenario: filter?.scenario ?? null,
    // project: filter?.Project ?? null,
    // po: filter?.PO ?? null,
    // siteLocation: filter?.SiteLocation ?? null,
  });

  await doSearchStoreAction({
    dispatch,
    getState,
    searchPageSliceActions,
    getStateSliceForSearchPage,
    searchParamBuilder,
    postResultsProcessHandler: null
  });
};
